var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2222 0H1.77779C0.795944 0 0 0.795941 0 1.77778V30.2222C0 31.2041 0.795944 32 1.77779 32H30.2222C31.2041 32 32 31.2041 32 30.2222V1.77778C32 0.795941 31.2041 0 30.2222 0Z",
    fill: "#FFDDA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0149 24.2897C23.0149 22.4294 22.2758 20.6453 20.9605 19.3298C19.645 18.0145 17.8609 17.2754 16.0006 17.2754C14.1402 17.2754 12.3562 18.0145 11.0408 19.3298C9.72533 20.6453 8.98633 22.4294 8.98633 24.2897H23.0149Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0183 10.656C19.165 11.0263 18.2447 11.2173 17.3146 11.2172C16.3886 11.2186 15.4718 11.033 14.6192 10.6714C13.7667 10.3098 12.9961 9.77968 12.3535 9.11286C12.7894 8.37104 13.4458 7.78364 14.2314 7.43246C15.0168 7.08127 15.8922 6.9838 16.7356 7.15363C17.5792 7.32343 18.3487 7.75209 18.9371 8.37987C19.5255 9.00765 19.9034 9.8033 20.0183 10.656Z",
    fill: "#C77F67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.007 19.3159C17.5105 19.3154 18.9744 19.7987 20.182 20.6945C21.3896 21.5902 22.2769 22.8507 22.7126 24.2897H23.0149C23.0149 22.4294 22.2758 20.6453 20.9605 19.3298C19.645 18.0145 17.8609 17.2754 16.0006 17.2754C14.1402 17.2754 12.3562 18.0145 11.0408 19.3298C9.72533 20.6453 8.98633 22.4294 8.98633 24.2897H9.28985C9.7277 22.8497 10.6171 21.5886 11.8267 20.693C13.0363 19.7974 14.5018 19.3146 16.007 19.3159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9244 9.1136C16.5938 9.11418 17.2528 9.27845 17.844 9.5921C18.4354 9.90574 18.941 10.3592 19.3168 10.9131C19.5548 10.8399 19.7888 10.7548 20.0183 10.658C19.9036 9.80523 19.5259 9.00944 18.9375 8.38149C18.3492 7.75353 17.5798 7.3247 16.7362 7.15473C15.8927 6.98477 15.0172 7.08213 14.2316 7.43323C13.446 7.78437 12.7895 8.37175 12.3535 9.1136C12.6651 9.43618 13.0067 9.72829 13.3738 9.98593C14.1023 9.41759 15.0004 9.11038 15.9244 9.1136Z",
    fill: "#E3BFB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0149 24.2897C23.0149 22.4294 22.2758 20.6453 20.9605 19.3298C19.645 18.0145 17.8609 17.2754 16.0006 17.2754C14.1402 17.2754 12.3562 18.0145 11.0408 19.3298C9.72533 20.6453 8.98633 22.4294 8.98633 24.2897H23.0149Z",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0304 10.6562H20.0176",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0183 10.656C19.165 11.0263 18.2447 11.2173 17.3146 11.2172C16.3886 11.2186 15.4718 11.033 14.6192 10.6714C13.7667 10.3098 12.9961 9.77968 12.3535 9.11286C12.7894 8.37104 13.4458 7.78364 14.2314 7.43246C15.0168 7.08127 15.8922 6.9838 16.7356 7.15363C17.5792 7.32343 18.3487 7.75209 18.9371 8.37987C19.5255 9.00764 19.9034 9.8033 20.0183 10.656Z",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0689 11.2176C20.0689 12.3168 19.6323 13.3712 18.8549 14.1484C18.0776 14.9257 17.0235 15.3624 15.9241 15.3624C14.8248 15.3624 13.7707 14.9257 12.9933 14.1484C12.216 13.3712 11.7793 12.3168 11.7793 11.2176C11.7833 10.478 11.9812 9.75244 12.3532 9.11328C12.9958 9.78011 13.7664 10.3102 14.6189 10.6718C15.4713 11.0334 16.3883 11.2191 17.3143 11.2176C18.2444 11.2177 19.1647 11.0267 20.018 10.6564C20.0544 10.8412 20.0715 11.0293 20.0689 11.2176Z",
    fill: "#FFDDA1",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_3584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.5091eea5a69c19b44caf80c1fffe2600.svg";
export { ForwardRef as ReactComponent };